import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotAsyncChat" */ './lazyIndex'),
    { name: 'CopilotAsyncChat' }
);

export const lazyStartAsyncChat: LazyAction<typeof lazyIndex.startAsyncChat, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.startAsyncChat);
export const lazyMarkAsyncItemRead: LazyAction<
    typeof lazyIndex.markAsyncItemRead,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.markAsyncItemRead);
export const lazySeedAsyncItemRegistry: LazyAction<
    typeof lazyIndex.seedAsyncItemRegistryFromGetChats,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.seedAsyncItemRegistryFromGetChats);

// Payload types
export type { StartAsyncChatPayload } from './commands/startAsyncChat';
export type { MarkAsyncItemReadPayload } from './commands/markAsyncItemRead';
export type { SeedAsyncItemRegistryFromGetChatsPayload } from './commands/seedAsyncItemRegistryFromGetChats';

// Mutators (used to seed the registry directly, e.g. in Storybook / test scenarios)
export { ensureAsyncItemRegistryMutator } from './mutators/ensureAsyncItemRegistryMutator';
export { upsertAsyncItemEntryMutator } from './mutators/upsertAsyncItemEntryMutator';
export { clearAsyncItemRegistryMutator } from './mutators/clearAsyncItemRegistryMutator';

// Selectors
export { getAllAsyncItemEntries } from './selectors/getAllAsyncItemEntries';
export { getAsyncItemEntry } from './selectors/getAsyncItemEntry';
export { getSeedStatus } from './selectors/getSeedStatus';

export { consumeCardShownDuration, markCardShown } from './services/cardShownTimes';

// Types + enums
export type {
    AsyncItemEntry,
    AsyncItem,
    AsyncItemSource,
    AsyncItemStatus,
    AsyncItemKind,
} from './store/schema/AsyncItemEntry';
export type { SeedStatus } from './store/schema/AsyncItemRegistry';
